module.exports = __webpack_public_path__ + "static/media/End-of-Subscription.25b40350.jpg";